export const UserFieldType = Object.freeze({
	String: 'string',
	Double: 'double',
	Boolean: 'boolean',
	Datetime: 'datetime',
});
